(() => {
 if(window.BBBirthProductImages) return;
 window.BBBirthProductImages = true;
 document.addEventListener('click', event => {
  const button = event.target.closest('[data-birth-product-photo]');
  if(!button) return;
  const root = button.closest('[data-birth-proposal]');
  const image = root?.querySelector('.bb-birth-teaser img');
  if(!image) return;
  image.removeAttribute('srcset');
  image.src = button.dataset.photoSrc;
  image.alt = button.dataset.photoAlt;
  image.width = Number(button.dataset.photoWidth);
  image.height = Number(button.dataset.photoHeight);
  button.parentElement.querySelectorAll('[data-birth-product-photo]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
 });
})();
